<script setup>
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faAngleLeft, faAngleRight, faAnglesLeft, faAnglesRight } from "@fortawesome/free-solid-svg-icons";

library.add(faAngleLeft, faAngleRight, faAnglesLeft, faAnglesRight)

const props = defineProps({ 
  pageData : Array,
  url : String
})
</script>

<template>
  <div class="css__flex-center">
    <p>{{ props.pageData.pages }}ページ中&nbsp;{{ props.pageData.selectedPage }}ページ目&nbsp;を表示中</p>
    <!-- 最初のページへ -->
    <a v-if="props.pageData.selectedPage > 2" class="css__link-icon" :href="props.url + '&page=1'">
      <font-awesome-icon icon="fa-solid fa-angles-left" size="lg" />
    </a>
    <a v-else class="css__link-icon" disabled>
      <font-awesome-icon icon="fa-solid fa-angles-left" size="lg" />
    </a>

    <!-- 前のページへ -->
    <a v-if="props.pageData.selectedPage > 1" class="css__link-icon" :href="props.url + '&page=' + (parseInt(props.pageData.selectedPage) - 1)">
      <font-awesome-icon icon="fa-solid fa-angle-left" size="lg" />
    </a>
    <a v-else class="css__link-icon" disabled>
      <font-awesome-icon icon="fa-solid fa-angle-left" size="lg" />
    </a>

    <span style="margin: 0 1.5em;">{{ props.pageData.selectedPage }}</span>

    <!-- 次のページへ -->
    <a v-if="props.pageData.pages > props.pageData.selectedPage" class="css__link-icon" :href="props.url + '&page=' + (parseInt(props.pageData.selectedPage) + 1)">
      <font-awesome-icon icon="fa-solid fa-angle-right" size="lg" />
    </a>
    <a v-else class="css__link-icon" disabled>
      <font-awesome-icon icon="fa-solid fa-angle-right" size="lg" />
    </a>

    <!-- 最後のページへ -->
    <a v-if="props.pageData.pages > props.pageData.selectedPage" class="css__link-icon" :href="props.url + '&page=' + props.pageData.pages">
      <font-awesome-icon icon="fa-solid fa-angles-right" size="lg" />
    </a>
    <a v-else class="css__link-icon" disabled>
      <font-awesome-icon icon="fa-solid fa-angles-right" size="lg" />
    </a>
  </div>
</template>

<style scoped>

</style>